exports = module.exports = require("../../../node_modules/.pnpm/css-loader@1.0.1_webpack@4.46.0/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".divider_divider_1_Adi {\n    border-right: 1px dashed var(--ui-black-transparent, hsla(55, 20%, 20%, 0.15));\n}\n", ""]);

// exports
exports.locals = {
	"divider": "divider_divider_1_Adi"
};